export const English = 'en';
export const EnglishAustralia = 'en-AU';
export const EnglishNewZealand = 'en-NZ';
export const EnglishUnitedKingdom = 'en-GB';
export const EnglishIreland = 'en-IE';
export const French = 'fr';
export const FrenchCanada = 'fr-CA';
export const Spanish = 'es';
export const Development = 'en-XA';
export const German = 'de';

export const AlternateLocaleMap = {
  [EnglishNewZealand]: EnglishAustralia,
  [EnglishIreland]: EnglishUnitedKingdom,
};

export const ShipStationSupportedLocales = [
  English,
  EnglishAustralia,
  EnglishUnitedKingdom,
  French,
  FrenchCanada,
  Spanish,
  German,
  Development,
];

export const LocaleCodeToFriendlyNameMap = {
  [English]: 'English (US & CA)',
  [EnglishAustralia]: 'English (AUS & NZ)',
  [EnglishUnitedKingdom]: 'English (UK & IE)',
  [French]: 'Français',
  [FrenchCanada]: 'Français (Canada)',
  [Spanish]: 'Español',
  [German]: 'Deutsch',
  [Development]: 'Development',
};
